import { render, staticRenderFns } from "./MainMenuItem.vue?vue&type=template&id=65cb32db&scoped=true"
import script from "./MainMenuItem.vue?vue&type=script&lang=js"
export * from "./MainMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MainMenuItem.vue?vue&type=style&index=0&id=65cb32db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb32db",
  null
  
)

export default component.exports